import React, { useRef } from 'react';
import { RadioGroup as TdsRadioGroup, FormItem } from '@tesla/react-tds/global';
import useFormField from '../../hooks/useFormField';

const RadioGroupContext = React.createContext();

const RadioGroup = ({ id, children, required, label, options, ...props }) => {
  const { defaultHandler, formFieldContext, render, userProps, formFieldRef } = useFormField({
    ...props,
    required,
  });

  const radioContainerRef = useRef();

  if (options) {
    return (
      <FormItem
        error={formFieldContext.$showError}
        errorLabel={formFieldContext.error}
        id={defaultHandler.id}
        label={label}
      >
        <TdsRadioGroup
          {...defaultHandler}
          id={id}
          required={Boolean(required)}
          options={options}
          currentValue={formFieldContext.value}
          {...userProps}
          ref={formFieldRef}
        />
      </FormItem>
    );
  }

  const context = {
    radioGroupHandler: {
      ...defaultHandler,
    },
    radioGroupContext: {
      name: userProps.name,
      ...formFieldContext,
    },
  };

  return render(
    <RadioGroupContext.Provider value={context}>
      <FormItem
        error={formFieldContext.$showError}
        errorLabel={formFieldContext.error}
        label={label}
      >
        <div
          className="tds-radio_buttons"
          role="radiogroup"
          aria-required={required ? 'true' : 'false'}
          aria-labelledby={id}
          ref={radioContainerRef}
        >
          {children}
        </div>
      </FormItem>
    </RadioGroupContext.Provider>
  );
};

export { RadioGroupContext };

export default RadioGroup;
